import { useCallback, useState } from "react";
import { SECTIONS } from "@/features/identity/sections";
import { hasErrors } from "@/features/identity/validation";
import { LAST_STEP } from "@/features/onboarding/steps";

const storageKey = (userId) => `mw-onboarding-step:${userId}`;

function initialStep(userId, profile, user) {
  const stored = Number(window.localStorage.getItem(storageKey(userId)));
  let start = Number.isInteger(stored) && stored >= 0 && stored <= LAST_STEP ? stored : 0;
  const identityOk = !hasErrors(SECTIONS.identity.validate(SECTIONS.identity.fromProfile(profile)));
  const contactOk = !hasErrors(SECTIONS.contact.validate(SECTIONS.contact.fromProfile(profile, user)));
  const firstIncomplete = !identityOk ? 1 : !contactOk ? 2 : null;
  if (firstIncomplete && start > firstIncomplete) start = firstIncomplete;
  return start;
}

export function useOnboardingStep(user, profile) {
  const [step, setStepState] = useState(() => initialStep(user.id, profile, user));

  const setStep = useCallback(
    (next) => {
      setStepState(next);
      window.localStorage.setItem(storageKey(user.id), String(next));
      window.scrollTo({ top: 0 });
    },
    [user.id],
  );
  const clear = useCallback(() => window.localStorage.removeItem(storageKey(user.id)), [user.id]);

  return { step, setStep, clear };
}
